<template>
  <v-chip v-bind:class="[ 'sf-pill', `sf-pill--${variant}` ]"
          small>
    {{ label }}
  </v-chip>
</template>

<script>
  const VARIANTS = {
    open: 'neutral',
    invited: 'info',
    accepted: 'success',
    declined: 'error'
  }

  export default {
    computed: {
      label() {
        return this.$te(this.state) ? this.$t(this.state) : this.state
      },
      variant() {
        return VARIANTS[this.state] || 'neutral'
      }
    },
    name: 'StateChip',
    props: {
      state: String
    }
  }
</script>

<i18n>
  {
    "de": {
      "open": "Offen",
      "invited": "Eingeladen",
      "accepted": "Akzeptiert",
      "declined": "Abgelehnt"
    },
    "en": {
      "open": "Open",
      "invited": "Invited",
      "accepted": "Accepted",
      "declined": "Declined"
    }
  }
</i18n>
